import { render, staticRenderFns } from "./TameMap.vue?vue&type=template&id=406753ea"
import script from "./TameMap.vue?vue&type=script&lang=js"
export * from "./TameMap.vue?vue&type=script&lang=js"
import style0 from "./TameMap.vue?vue&type=style&index=0&id=406753ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports